var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import Stretch from './Stretch';
import { Eagers } from '../../helpers/Eagers';
export default class StretchesStore {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            this.data = values.map((item) => new Stretch(item));
            this.loaded = true;
            return this.data;
        };
        this.push = (value) => {
            this.data.push(new Stretch(value));
        };
    }
    read(id) {
        // console.log('Stretches/Store - read')
        if (id) {
            return api.get(`stretches/${id}?eager=${Eagers.stretch}`);
        }
        return api.get(`stretches?eager=${Eagers.stretch}`)
            // .then(this.set)
            .then((value) => {
            // console.log('Stretches/Store - read() - value', value)
            return this.set(value);
        });
    }
    setData(values) {
        this.set(values);
    }
    findBusinessunitByStretchId(id) {
        return this.data.filter(value => value.id === id)[0];
    }
}
__decorate([
    observable
], StretchesStore.prototype, "data", void 0);
__decorate([
    observable
], StretchesStore.prototype, "loaded", void 0);
__decorate([
    action
], StretchesStore.prototype, "set", void 0);
__decorate([
    action
], StretchesStore.prototype, "push", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/StretchesStore.ts
// module id = 568
// module chunks = 0